module.exports = __webpack_public_path__ + "img/portraits_09_V.8d0c688b.webp";